import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

import { GiantNavigationComponent } from './navigation.component';
import { GiantNavVerticalGroupComponent } from './vertical/group/group.component';
import { GiantNavVerticalCollapsableComponent } from './vertical/collapsable/collapsable.component';
import { GiantNavVerticalItemComponent } from './vertical/item/item.component';

@NgModule({
    imports     : [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatRippleModule,
    ],
    exports     : [
        GiantNavigationComponent
    ],
    declarations: [
        GiantNavigationComponent,
        GiantNavVerticalGroupComponent,
        GiantNavVerticalItemComponent,
        GiantNavVerticalCollapsableComponent,
   
    ]
})
export class GiantNavigationModule
{
}
